function Sobre() {
    return (
        <div className="global-pageContainer-left">
            <div className="contribute-container">
                <h1>Sobre</h1>
                <p className="global-mt">
                    O <strong>Tabuada Divertida</strong> é uma plataforma criada para ajudar crianças e estudantes de todas as idades a praticarem operações matemáticas de forma leve, interativa e divertida.
                </p>
                <p className="global-mt">
                    Nosso objetivo é transformar o aprendizado da matemática em uma experiência prazerosa, utilizando jogos simples e desafios com rankings para estimular a evolução e a prática constante.
                </p>
                <p className="global-mt">
                    A plataforma é gratuita, responsiva e pode ser utilizada tanto por pais e responsáveis quanto por professores em sala de aula.
                </p>
                <p className="global-mt">
                    Desenvolvido com <span style={{ color: 'var(--button-color-primary)', fontWeight: 'bold' }}>❤</span> por Rodrigo Machado.
                </p>
            </div>
        </div>
    );
}

export default Sobre;
